<template>
  <div class="score">
    <i :class="{ full: score>=1,half: score==0.5 }"></i>
    <i :class="{ full: score>=2,half: score==1.5 }"></i>
    <i :class="{ full: score>=3,half: score==2.5 }"></i>
    <i :class="{ full: score>=4,half: score==3.5 }"></i>
    <i :class="{ full: score>=5,half: score==4.5 }"></i>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      default: 4.5
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  components: {}, 
};
</script>

<style scoped lang='less'>
.score {
  display: flex;
  padding: 16px 0 8px;

  i {
    width: 15px;
    height: 16px;
    background: url("./images/start_empty.png") no-repeat;
    background-size: cover;
    background-position: center center;
    @media (max-width: 992px) {
      width: 8px;
      height: 8px;
    }
    &.full {
      background: url("./images/start_full.png") no-repeat;
      background-size: cover;
      background-position: center center;
    }
    &.half {
      background: url("./images/star_half.png") no-repeat;
      background-size: cover;
      background-position: center center;
    }
  }
}
</style>
